import React from "react";

import { Skeleton } from "@packages/ds";

import * as S from "./styles";

const FlamebearerTableSkeleton = () => {
  return (
    <S.Container numberOfLines={10}>
      <Skeleton synchronize className="skeleton">
        <Skeleton.Square height="300px" width="100%" />
      </Skeleton>
    </S.Container>
  );
};

export default FlamebearerTableSkeleton;
